import React, { useEffect, useState } from 'react'
import { hasPermission, removeUndefinedValues } from '../../config-func'
import {
  OPTIONS_DEPOSIT,
  OPTIONS_PACKAGE_STATUS,
  PAGE_SIZE_OPTIONS,
  TagCustom
} from '../../configData'
import { listRechargePromotionHistory } from '../../services/recharge-promotion'
import Card from '../Card'
import ModalConfirm from '../common/ModalConfirm/ModalConfirm'
import TableField from '../common/Table/TableField'
import AuthenticatedLink from '../Export/AuthenticatedLink'
import FilterForm from './FilterForm'
import dayjs from 'dayjs'
import openNotification from '../common/Notification/openNotification '
import Loading from '../Loading';

const RechargePromotionsHistory = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState('')
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      textSearch: filters.textSearch || '',
      payment_method: filters.payment_method || '',
      status: filters.status || '',
      date_start:
        (filters?.date && filters?.date[0]?.format('DD/MM/YYYY')) || '',
      date_end: (filters?.date && filters.date[1]?.format('DD/MM/YYYY')) || ''
    }

    try {
      const response = await listRechargePromotionHistory(
        removeUndefinedValues(params || {})
      )

      // if (response?.code === 0) {
      _total = response?.total
      _dataSource = response?.data
      // }
    } catch (error) {
      openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Họ tên',
      dataIndex: 'full_name',
      key: 'full_name',
      width: 150,
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 150,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 220
    },
    {
      title: 'Mã giao dịch',
      dataIndex: 'tx_code',
      key: 'tx_code',
      width: 150,
    },
    {
      title: 'TKC',
      dataIndex: 'amount',
      key: 'amount',
      width: 150,
    },
    {
      title: 'TKKM',
      dataIndex: 'promotion_amount',
      key: 'promotion_amount',
      width: 100
    },
    {
      title: 'Thời gian',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      // render: (_, record) => dayjs(Number(record.created_at)).format('DD/MM/YYYY')
      render: (_, record) =>
        record?.created_at
          ? dayjs.unix(Number(record.created_at)).format('DD/MM/YYYY HH:mm:ss')
          : ''

    },
    {
      title: 'Trang thái',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      // render: (_, record) => {
      //   return (
      //     <div>
      //       {OPTIONS_PACKAGE_STATUS.find((item) => item.value === record.status)
      //         ?.name || ''}
      //     </div>
      //   )
      // }
      render: (_, record) => (
        <TagCustom arr={OPTIONS_PACKAGE_STATUS} status={record.status} />
      )
    },
    {
      title: 'Hình thức',
      dataIndex: 'payment_method',
      key: 'payment_method',
      width: 150,
      render: (_, record) => {
        return (
          <div>
            {OPTIONS_DEPOSIT.find((item) => item.value == record.payment_method)
              ?.name || record.payment_method}
          </div>
        )
      }
    }
  ]

  useEffect(() => {
    const p = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      textSearch: filters.textSearch || '',
      payment_method: filters.payment_method || '',
      status: filters.status || '',
      date_start:
        (filters?.date && filters?.date[0]?.format('DD/MM/YYYY')) || '',
      date_end: (filters?.date && filters.date[1]?.format('DD/MM/YYYY')) || ''
    }

    const params = new URLSearchParams({ ...p })

    setUrl(
      `${process.env.REACT_APP_API_URL}/api/v1/project-recommend/register/export?` +
        params
    )
  }, [filters])
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        ></div>

        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {hasPermission('P52.1', permissions) && (
          <AuthenticatedLink
            url={url}
            filename={
              filters.type_request == 1
                ? 'Danh-sach-xem-can-ho-mau'
                : filters.type_request == 2
                ? 'Danh-sach-nhan-thong-tin'
                : 'Danh-sach-xem-can-ho-va-danh-sach-nhan-thong-tin'
            }
          >
            Export
          </AuthenticatedLink>
          )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      <ModalConfirm />
    </div>
  )
}

export default RechargePromotionsHistory
